module.exports = __webpack_public_path__ + "src/assets/textures/env/fence/fence_03_1k_bake.png";